module.exports = __webpack_public_path__ + "img/9.f8c758f6.svg";